<ng-container *ngIf="!data.skeletonLoading; else skeletonLoadingWidget">
    <div class="opp-card-wrap" [class.has-image]="hasImage" [class.closed]="isClosed" proBadge [show]="opp.is_prime>0">
        <a class="opp-card" routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}"
            (click)="trackOppWidgetEvent('Opportunity widget', 'Click-Detail', fromForGA); goToOppDetailPage($event);">
            <img class="opp-logo" [lazyLoad]="opp.opimage+'?w=300'" [alt]="opp.opporname"
                defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-opp-image.png">

            <div class="opp-tags">
                <span class="opp-tag opp-tag-soon" *ngIf="isClosingSoon">Closing Soon</span>
                <span class="opp-tag opp-tag-new" *ngIf="isNew && !isClosed && !isClosingSoon">New</span>
                <span class="opp-tag opp-cap" *ngIf="typeLabel">{{typeLabel}}</span>
            </div>

            <div class="opp-body">
                <div class="opp-info">
                    <div class="opp-head">
                        <span class="opp-name opp-cap">{{partnerName}}</span>
                    </div>
                    <div class="opp-text">
                        <h3 class="opp-title">{{opp.opporname}}</h3>
                        <p class="opp-sub">{{subtitle}}</p>
                    </div>
                    <div class="opp-lang" *ngIf="languages">
                        <img src="assets/opp-widget/language.svg" width="16" height="16" alt="">
                        <span>{{languages}}</span>
                    </div>
                </div>

                <div class="opp-banner" *ngIf="hasImage">
                    <img [lazyLoad]="opp.card_image+'?w=700'" [alt]="opp.opporname">
                </div>

                <div class="opp-foot">
                    <div class="opp-foot-row">
                        <span class="opp-date" *ngIf="!isClosed && !isApplied">
                            <img src="assets/opp-widget/calendar.svg" width="16" height="16" alt="">
                            {{isUpcoming ? 'Upcoming' : global.formatedDate(opp.last_date_application)}}
                        </span>
                        <span class="opp-tag opp-tag-status" *ngIf="isClosed || isApplied">{{isClosed ? 'Closed' : 'Applied'}}</span>
                        <span class="opp-cta">View Opportunity</span>
                    </div>
                </div>
            </div>
        </a>
    </div>
</ng-container>

<ng-template #skeletonLoadingWidget>
    <div class="opp-skeleton skeletonLoading"></div>
</ng-template>
